import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Shield, Clock, Users, Award, Heart, Star } from "lucide-react";
const WhyChooseUsSection = () => {
  const reasons = [{
    icon: Shield,
    title: "Licensed & Insured",
    description: "Fully licensed and insured for your peace of mind. We carry comprehensive liability and workers' compensation insurance.",
    badge: "Protected"
  }, {
    icon: Clock,
    title: "Punctual & Reliable",
    description: "We respect your time and arrive exactly when scheduled. Consistent service you can count on, every time.",
    badge: "On Time"
  }, {
    icon: Users,
    title: "Trained Professionals",
    description: "Our team undergoes rigorous training and background checks. Only the most dedicated cleaners join our team.",
    badge: "Certified"
  }, {
    icon: Award,
    title: "Quality Guaranteed",
    description: "100% satisfaction guarantee on every service. If you're not happy, we'll make it right at no additional cost.",
    badge: "Guaranteed"
  }, {
    icon: Heart,
    title: "Personalized Service",
    description: "We tailor our cleaning approach to your specific needs and preferences. Your home, your way.",
    badge: "Custom"
  }, {
    icon: Star,
    title: "5-Star Reviews",
    description: "Consistently rated 5 stars by our customers across Connecticut. Join hundreds of satisfied families.",
    badge: "Top Rated"
  }];
  return <section className="py-20 bg-gradient-to-b from-muted to-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Why Choose <span className="bg-gradient-to-r from-brand-gold-dark to-brand-gold-light bg-clip-text text-transparent">Routine Cleaners?</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            We're not just another cleaning company. We're your trusted partners in maintaining 
            a clean, healthy, and comfortable environment for what matters most to you.
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {reasons.map((reason, index) => {
          const IconComponent = reason.icon;
          return <Card key={index} className="group hover:shadow-xl transition-all duration-300 border-border hover:border-accent/20 bg-card">
                <CardHeader className="text-center">
                  <div className="mx-auto mb-4 p-4 bg-accent/10 rounded-full w-fit group-hover:bg-accent group-hover:text-accent-foreground transition-all duration-300">
                    <IconComponent className="h-8 w-8 text-accent group-hover:text-accent-foreground" />
                  </div>
                  <div className="flex items-center justify-center mb-2">
                    <Badge variant="secondary" className="bg-accent/10 text-accent border-accent/20 font-semibold">
                      {reason.badge}
                    </Badge>
                  </div>
                  <CardTitle className="text-foreground">{reason.title}</CardTitle>
                </CardHeader>
                
                <CardContent className="text-center">
                  <p className="text-muted-foreground">{reason.description}</p>
                </CardContent>
              </Card>;
        })}
        </div>

        {/* Stats Section */}
        <div className="bg-primary rounded-2xl p-8 lg:p-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl lg:text-4xl font-bold text-primary-foreground mb-2">500+</div>
              <div className="text-primary-foreground/80">Happy Customers</div>
            </div>
            <div>
              <div className="text-3xl lg:text-4xl font-bold text-primary-foreground mb-2">5.0★</div>
              <div className="text-primary-foreground/80">Average Rating</div>
            </div>
            <div>
              <div className="text-3xl lg:text-4xl font-bold text-primary-foreground mb-2">5+</div>
              <div className="text-primary-foreground/80">Years Experience</div>
            </div>
            <div>
              <div className="text-3xl lg:text-4xl font-bold text-primary-foreground mb-2">100%</div>
              <div className="text-primary-foreground/80">Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default WhyChooseUsSection;